<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.86389 7.99697C2.27021 7.92581 1 6.61124 1 5C1 3.34315 2.34315 2 4 2H21C22.6569 2 24 3.34315 24 5C24 6.61124 22.7298 7.9258 21.1361 7.99697L15.8333 14.9268L15.8333 21.9999C15.8333 23.1045 14.9379 23.9999 13.8333 23.9999H11.1667C10.0621 23.9999 9.16667 23.1045 9.16667 21.9999V14.9268L3.86389 7.99697ZM4.85416 6L4.79417 5.9216L4.6917 6H4C3.44772 6 3 5.55228 3 5C3 4.44772 3.44772 4 4 4H21C21.5523 4 22 4.44772 22 5C22 5.55228 21.5523 6 21 6H20.3083L20.2058 5.9216L20.1458 6H4.85416ZM6.38457 8L10.755 13.7114C11.022 14.0603 11.1667 14.4875 11.1667 14.9268V21.9999H13.8333V14.9268C13.8333 14.4875 13.978 14.0603 14.245 13.7114L18.6154 8H6.38457Z"
      fill="currentColor"
    />
  </svg>
</template>
